/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './shared/routes/__root';
import { Route as StatusRouteImport } from './shared/routes/status';
import { Route as ProjectsRouteImport } from './shared/routes/projects';
import { Route as PerformanceRouteImport } from './shared/routes/performance';
import { Route as ExperienceRouteImport } from './shared/routes/experience';
import { Route as CaseStudiesRouteImport } from './shared/routes/case-studies';
import { Route as BlogRouteImport } from './shared/routes/blog';
import { Route as ArchitectureRouteImport } from './shared/routes/architecture';
import { Route as AccessibilityRouteImport } from './shared/routes/accessibility';
import { Route as AboutRouteImport } from './shared/routes/about';
import { Route as IndexRouteImport } from './shared/routes/index';
import { Route as StatusIndexRouteImport } from './shared/routes/status.index';
import { Route as CaseStudiesIndexRouteImport } from './shared/routes/case-studies.index';
import { Route as BlogIndexRouteImport } from './shared/routes/blog.index';
import { Route as ArchitectureIndexRouteImport } from './shared/routes/architecture.index';
import { Route as StatusTracesRouteImport } from './shared/routes/status.traces';
import { Route as CaseStudiesSlugRouteImport } from './shared/routes/case-studies.$slug';
import { Route as BlogCreateRouteImport } from './shared/routes/blog.create';
import { Route as BlogSlugRouteImport } from './shared/routes/blog.$slug';
import { Route as ArchitectureDependenciesRouteImport } from './shared/routes/architecture.dependencies';
import { Route as ArchitectureSlugRouteImport } from './shared/routes/architecture.$slug';
import { Route as StatusTracesIndexRouteImport } from './shared/routes/status.traces.index';
import { Route as StatusTracesTraceIdRouteImport } from './shared/routes/status.traces.$traceId';
import { Route as ArchitectureComponentsSlugRouteImport } from './shared/routes/architecture.components.$slug';

const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any);
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any);
const PerformanceRoute = PerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => rootRouteImport,
} as any);
const ExperienceRoute = ExperienceRouteImport.update({
  id: '/experience',
  path: '/experience',
  getParentRoute: () => rootRouteImport,
} as any);
const CaseStudiesRoute = CaseStudiesRouteImport.update({
  id: '/case-studies',
  path: '/case-studies',
  getParentRoute: () => rootRouteImport,
} as any);
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any);
const ArchitectureRoute = ArchitectureRouteImport.update({
  id: '/architecture',
  path: '/architecture',
  getParentRoute: () => rootRouteImport,
} as any);
const AccessibilityRoute = AccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any);
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const StatusIndexRoute = StatusIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StatusRoute,
} as any);
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CaseStudiesRoute,
} as any);
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any);
const ArchitectureIndexRoute = ArchitectureIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArchitectureRoute,
} as any);
const StatusTracesRoute = StatusTracesRouteImport.update({
  id: '/traces',
  path: '/traces',
  getParentRoute: () => StatusRoute,
} as any);
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => CaseStudiesRoute,
} as any);
const BlogCreateRoute = BlogCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => BlogRoute,
} as any);
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any);
const ArchitectureDependenciesRoute =
  ArchitectureDependenciesRouteImport.update({
    id: '/dependencies',
    path: '/dependencies',
    getParentRoute: () => ArchitectureRoute,
  } as any);
const ArchitectureSlugRoute = ArchitectureSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ArchitectureRoute,
} as any);
const StatusTracesIndexRoute = StatusTracesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StatusTracesRoute,
} as any);
const StatusTracesTraceIdRoute = StatusTracesTraceIdRouteImport.update({
  id: '/$traceId',
  path: '/$traceId',
  getParentRoute: () => StatusTracesRoute,
} as any);
const ArchitectureComponentsSlugRoute =
  ArchitectureComponentsSlugRouteImport.update({
    id: '/components/$slug',
    path: '/components/$slug',
    getParentRoute: () => ArchitectureRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/accessibility': typeof AccessibilityRoute;
  '/architecture': typeof ArchitectureRouteWithChildren;
  '/blog': typeof BlogRouteWithChildren;
  '/case-studies': typeof CaseStudiesRouteWithChildren;
  '/experience': typeof ExperienceRoute;
  '/performance': typeof PerformanceRoute;
  '/projects': typeof ProjectsRoute;
  '/status': typeof StatusRouteWithChildren;
  '/architecture/$slug': typeof ArchitectureSlugRoute;
  '/architecture/dependencies': typeof ArchitectureDependenciesRoute;
  '/blog/$slug': typeof BlogSlugRoute;
  '/blog/create': typeof BlogCreateRoute;
  '/case-studies/$slug': typeof CaseStudiesSlugRoute;
  '/status/traces': typeof StatusTracesRouteWithChildren;
  '/architecture/': typeof ArchitectureIndexRoute;
  '/blog/': typeof BlogIndexRoute;
  '/case-studies/': typeof CaseStudiesIndexRoute;
  '/status/': typeof StatusIndexRoute;
  '/architecture/components/$slug': typeof ArchitectureComponentsSlugRoute;
  '/status/traces/$traceId': typeof StatusTracesTraceIdRoute;
  '/status/traces/': typeof StatusTracesIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/accessibility': typeof AccessibilityRoute;
  '/experience': typeof ExperienceRoute;
  '/performance': typeof PerformanceRoute;
  '/projects': typeof ProjectsRoute;
  '/architecture/$slug': typeof ArchitectureSlugRoute;
  '/architecture/dependencies': typeof ArchitectureDependenciesRoute;
  '/blog/$slug': typeof BlogSlugRoute;
  '/blog/create': typeof BlogCreateRoute;
  '/case-studies/$slug': typeof CaseStudiesSlugRoute;
  '/architecture': typeof ArchitectureIndexRoute;
  '/blog': typeof BlogIndexRoute;
  '/case-studies': typeof CaseStudiesIndexRoute;
  '/status': typeof StatusIndexRoute;
  '/architecture/components/$slug': typeof ArchitectureComponentsSlugRoute;
  '/status/traces/$traceId': typeof StatusTracesTraceIdRoute;
  '/status/traces': typeof StatusTracesIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/accessibility': typeof AccessibilityRoute;
  '/architecture': typeof ArchitectureRouteWithChildren;
  '/blog': typeof BlogRouteWithChildren;
  '/case-studies': typeof CaseStudiesRouteWithChildren;
  '/experience': typeof ExperienceRoute;
  '/performance': typeof PerformanceRoute;
  '/projects': typeof ProjectsRoute;
  '/status': typeof StatusRouteWithChildren;
  '/architecture/$slug': typeof ArchitectureSlugRoute;
  '/architecture/dependencies': typeof ArchitectureDependenciesRoute;
  '/blog/$slug': typeof BlogSlugRoute;
  '/blog/create': typeof BlogCreateRoute;
  '/case-studies/$slug': typeof CaseStudiesSlugRoute;
  '/status/traces': typeof StatusTracesRouteWithChildren;
  '/architecture/': typeof ArchitectureIndexRoute;
  '/blog/': typeof BlogIndexRoute;
  '/case-studies/': typeof CaseStudiesIndexRoute;
  '/status/': typeof StatusIndexRoute;
  '/architecture/components/$slug': typeof ArchitectureComponentsSlugRoute;
  '/status/traces/$traceId': typeof StatusTracesTraceIdRoute;
  '/status/traces/': typeof StatusTracesIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/about'
    | '/accessibility'
    | '/architecture'
    | '/blog'
    | '/case-studies'
    | '/experience'
    | '/performance'
    | '/projects'
    | '/status'
    | '/architecture/$slug'
    | '/architecture/dependencies'
    | '/blog/$slug'
    | '/blog/create'
    | '/case-studies/$slug'
    | '/status/traces'
    | '/architecture/'
    | '/blog/'
    | '/case-studies/'
    | '/status/'
    | '/architecture/components/$slug'
    | '/status/traces/$traceId'
    | '/status/traces/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/about'
    | '/accessibility'
    | '/experience'
    | '/performance'
    | '/projects'
    | '/architecture/$slug'
    | '/architecture/dependencies'
    | '/blog/$slug'
    | '/blog/create'
    | '/case-studies/$slug'
    | '/architecture'
    | '/blog'
    | '/case-studies'
    | '/status'
    | '/architecture/components/$slug'
    | '/status/traces/$traceId'
    | '/status/traces';
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/accessibility'
    | '/architecture'
    | '/blog'
    | '/case-studies'
    | '/experience'
    | '/performance'
    | '/projects'
    | '/status'
    | '/architecture/$slug'
    | '/architecture/dependencies'
    | '/blog/$slug'
    | '/blog/create'
    | '/case-studies/$slug'
    | '/status/traces'
    | '/architecture/'
    | '/blog/'
    | '/case-studies/'
    | '/status/'
    | '/architecture/components/$slug'
    | '/status/traces/$traceId'
    | '/status/traces/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AboutRoute: typeof AboutRoute;
  AccessibilityRoute: typeof AccessibilityRoute;
  ArchitectureRoute: typeof ArchitectureRouteWithChildren;
  BlogRoute: typeof BlogRouteWithChildren;
  CaseStudiesRoute: typeof CaseStudiesRouteWithChildren;
  ExperienceRoute: typeof ExperienceRoute;
  PerformanceRoute: typeof PerformanceRoute;
  ProjectsRoute: typeof ProjectsRoute;
  StatusRoute: typeof StatusRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/status': {
      id: '/status';
      path: '/status';
      fullPath: '/status';
      preLoaderRoute: typeof StatusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/projects': {
      id: '/projects';
      path: '/projects';
      fullPath: '/projects';
      preLoaderRoute: typeof ProjectsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/performance': {
      id: '/performance';
      path: '/performance';
      fullPath: '/performance';
      preLoaderRoute: typeof PerformanceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/experience': {
      id: '/experience';
      path: '/experience';
      fullPath: '/experience';
      preLoaderRoute: typeof ExperienceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/case-studies': {
      id: '/case-studies';
      path: '/case-studies';
      fullPath: '/case-studies';
      preLoaderRoute: typeof CaseStudiesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/blog': {
      id: '/blog';
      path: '/blog';
      fullPath: '/blog';
      preLoaderRoute: typeof BlogRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/architecture': {
      id: '/architecture';
      path: '/architecture';
      fullPath: '/architecture';
      preLoaderRoute: typeof ArchitectureRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accessibility': {
      id: '/accessibility';
      path: '/accessibility';
      fullPath: '/accessibility';
      preLoaderRoute: typeof AccessibilityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/about': {
      id: '/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof AboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/status/': {
      id: '/status/';
      path: '/';
      fullPath: '/status/';
      preLoaderRoute: typeof StatusIndexRouteImport;
      parentRoute: typeof StatusRoute;
    };
    '/case-studies/': {
      id: '/case-studies/';
      path: '/';
      fullPath: '/case-studies/';
      preLoaderRoute: typeof CaseStudiesIndexRouteImport;
      parentRoute: typeof CaseStudiesRoute;
    };
    '/blog/': {
      id: '/blog/';
      path: '/';
      fullPath: '/blog/';
      preLoaderRoute: typeof BlogIndexRouteImport;
      parentRoute: typeof BlogRoute;
    };
    '/architecture/': {
      id: '/architecture/';
      path: '/';
      fullPath: '/architecture/';
      preLoaderRoute: typeof ArchitectureIndexRouteImport;
      parentRoute: typeof ArchitectureRoute;
    };
    '/status/traces': {
      id: '/status/traces';
      path: '/traces';
      fullPath: '/status/traces';
      preLoaderRoute: typeof StatusTracesRouteImport;
      parentRoute: typeof StatusRoute;
    };
    '/case-studies/$slug': {
      id: '/case-studies/$slug';
      path: '/$slug';
      fullPath: '/case-studies/$slug';
      preLoaderRoute: typeof CaseStudiesSlugRouteImport;
      parentRoute: typeof CaseStudiesRoute;
    };
    '/blog/create': {
      id: '/blog/create';
      path: '/create';
      fullPath: '/blog/create';
      preLoaderRoute: typeof BlogCreateRouteImport;
      parentRoute: typeof BlogRoute;
    };
    '/blog/$slug': {
      id: '/blog/$slug';
      path: '/$slug';
      fullPath: '/blog/$slug';
      preLoaderRoute: typeof BlogSlugRouteImport;
      parentRoute: typeof BlogRoute;
    };
    '/architecture/dependencies': {
      id: '/architecture/dependencies';
      path: '/dependencies';
      fullPath: '/architecture/dependencies';
      preLoaderRoute: typeof ArchitectureDependenciesRouteImport;
      parentRoute: typeof ArchitectureRoute;
    };
    '/architecture/$slug': {
      id: '/architecture/$slug';
      path: '/$slug';
      fullPath: '/architecture/$slug';
      preLoaderRoute: typeof ArchitectureSlugRouteImport;
      parentRoute: typeof ArchitectureRoute;
    };
    '/status/traces/': {
      id: '/status/traces/';
      path: '/';
      fullPath: '/status/traces/';
      preLoaderRoute: typeof StatusTracesIndexRouteImport;
      parentRoute: typeof StatusTracesRoute;
    };
    '/status/traces/$traceId': {
      id: '/status/traces/$traceId';
      path: '/$traceId';
      fullPath: '/status/traces/$traceId';
      preLoaderRoute: typeof StatusTracesTraceIdRouteImport;
      parentRoute: typeof StatusTracesRoute;
    };
    '/architecture/components/$slug': {
      id: '/architecture/components/$slug';
      path: '/components/$slug';
      fullPath: '/architecture/components/$slug';
      preLoaderRoute: typeof ArchitectureComponentsSlugRouteImport;
      parentRoute: typeof ArchitectureRoute;
    };
  }
}

interface ArchitectureRouteChildren {
  ArchitectureSlugRoute: typeof ArchitectureSlugRoute;
  ArchitectureDependenciesRoute: typeof ArchitectureDependenciesRoute;
  ArchitectureIndexRoute: typeof ArchitectureIndexRoute;
  ArchitectureComponentsSlugRoute: typeof ArchitectureComponentsSlugRoute;
}

const ArchitectureRouteChildren: ArchitectureRouteChildren = {
  ArchitectureSlugRoute: ArchitectureSlugRoute,
  ArchitectureDependenciesRoute: ArchitectureDependenciesRoute,
  ArchitectureIndexRoute: ArchitectureIndexRoute,
  ArchitectureComponentsSlugRoute: ArchitectureComponentsSlugRoute,
};

const ArchitectureRouteWithChildren = ArchitectureRoute._addFileChildren(
  ArchitectureRouteChildren,
);

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute;
  BlogCreateRoute: typeof BlogCreateRoute;
  BlogIndexRoute: typeof BlogIndexRoute;
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
  BlogCreateRoute: BlogCreateRoute,
  BlogIndexRoute: BlogIndexRoute,
};

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren);

interface CaseStudiesRouteChildren {
  CaseStudiesSlugRoute: typeof CaseStudiesSlugRoute;
  CaseStudiesIndexRoute: typeof CaseStudiesIndexRoute;
}

const CaseStudiesRouteChildren: CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,
  CaseStudiesIndexRoute: CaseStudiesIndexRoute,
};

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(
  CaseStudiesRouteChildren,
);

interface StatusTracesRouteChildren {
  StatusTracesTraceIdRoute: typeof StatusTracesTraceIdRoute;
  StatusTracesIndexRoute: typeof StatusTracesIndexRoute;
}

const StatusTracesRouteChildren: StatusTracesRouteChildren = {
  StatusTracesTraceIdRoute: StatusTracesTraceIdRoute,
  StatusTracesIndexRoute: StatusTracesIndexRoute,
};

const StatusTracesRouteWithChildren = StatusTracesRoute._addFileChildren(
  StatusTracesRouteChildren,
);

interface StatusRouteChildren {
  StatusTracesRoute: typeof StatusTracesRouteWithChildren;
  StatusIndexRoute: typeof StatusIndexRoute;
}

const StatusRouteChildren: StatusRouteChildren = {
  StatusTracesRoute: StatusTracesRouteWithChildren,
  StatusIndexRoute: StatusIndexRoute,
};

const StatusRouteWithChildren =
  StatusRoute._addFileChildren(StatusRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccessibilityRoute: AccessibilityRoute,
  ArchitectureRoute: ArchitectureRouteWithChildren,
  BlogRoute: BlogRouteWithChildren,
  CaseStudiesRoute: CaseStudiesRouteWithChildren,
  ExperienceRoute: ExperienceRoute,
  PerformanceRoute: PerformanceRoute,
  ProjectsRoute: ProjectsRoute,
  StatusRoute: StatusRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
